module.exports = __webpack_public_path__ + "img/benoit2.7bd00430.jpg";